import { Browser } from '@capacitor/browser';

export const openWhatsApp = async (phone: string, message?: string) => {
  if (!phone) return;

  const cleanPhone = phone.replace(/[^\d+]/g, '');
  const defaultMessage = "¡Hola! Me comunico contigo desde nuestra plataforma.";
  const finalMessage = message || defaultMessage;

  const whatsappUrl = `whatsapp://send?phone=${cleanPhone}&text=${encodeURIComponent(finalMessage)}`;
  const fallbackUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(finalMessage)}`;

  try {
    await Browser.open({ url: whatsappUrl });
  } catch (err) {
    console.warn('No se pudo abrir la app de WhatsApp, abriendo en navegador...');
    await Browser.open({ url: fallbackUrl });
  }
};

export const openEmail = (email: string, subject?: string, body?: string) => {
  if (!email) return

  const params = new URLSearchParams()
  if (subject) params.append("subject", subject)
  if (body) params.append("body", body)

  const emailUrl = `mailto:${email}${params.toString() ? `?${params.toString()}` : ""}`

  window.location.href = emailUrl
}

export const formatPhone = (phone: string) => {
  if (!phone) return ""

  if (phone.includes("-") || phone.includes(" ")) return phone

  const cleaned = phone.replace(/\D/g, "")
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }
  if (cleaned.length === 12 && cleaned.startsWith("52")) {
    return `+52 ${cleaned.slice(2, 5)}-${cleaned.slice(5, 8)}-${cleaned.slice(8)}`
  }

  return phone
}

export const formatDate = (dateString: string, options: Intl.DateTimeFormatOptions = {}) => {
  const date = new Date(dateString)

  // TODO: Use Intl.DateTimeFormat
  // const defaultOptions: Intl.DateTimeFormatOptions = {
  //   year: "numeric",
  //   month: "long",
  //   day: "numeric",
  //   hour: "2-digit",
  //   minute: "2-digit",
  //   ...options,
  // }

  return date.toLocaleString("es-ES")
}